import { defineFcm } from '../shared/factory';

export const FCM_DATA_DISABLE_PETSVC_SALESFORCE_WORKER = defineFcm('data_disable_petsvc_salesforce_worker')
	.asBoolean()
	.withDefault(false)
	.toConfig({
		owner: 'squad-site-platform',
		scope: 'TBD',
		context: 'Petition Service',
		description: `Disables the worker that writes data to Salesforce.

			This will allow us to transition the writes to the new AWS Glue ETL process.`,
		import: false,
	});
